import styled from 'styled-components';

export const Container = styled.div`
  padding: 1px;
  border-radius: 4px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ backgroundColor }) => backgroundColor};
  min-width: 45px;
  
  img {
    width: 35px;
    height: 35px;
  }
`;

export const Date = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  text-align: center;
  line-height: 8px;
  color: white;
  gap: 1px;
  font-size: 8px;

  span {
    text-transform: uppercase;
  }

  .calendar-time {
    font-size: 6px;
  }

  .calendar-inline-date {
    font-size: 7px;
    margin-top: 3px;
  }
`;
